/** True when the value can be used as an <img src> (http(s), data URI, blob, or site path). */
export function isUsableAvatarUrl(url?: string | null): boolean {
  const trimmed = (url || "").trim();
  if (!trimmed) return false;
  return (
    trimmed.startsWith("https://") ||
    trimmed.startsWith("http://") ||
    trimmed.startsWith("data:image/") ||
    trimmed.startsWith("blob:") ||
    trimmed.startsWith("/")
  );
}

export function timeAgo(seconds:number):string {
    const now = Math.floor(Date.now() / 1000);
    const diff = now - seconds;
    if (diff < 60) return "0 min ago";
    if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    if (diff < 2592000) return `${Math.floor(diff / 86400)}d ago`;
    if (diff < 31536000) return `${Math.floor(diff / 2592000)}m ago`;
    return `${Math.floor(diff / 31536000)}y ago`;
  }